import { jwtDecode } from 'jwt-decode';

const ACCESS_TOKEN_KEY  = 'dp_access_token';
const REFRESH_TOKEN_KEY = 'dp_refresh_token';
const USER_KEY          = 'dp_user';

// ── Save tokens after login ──────────────────────────
export const saveTokens = (accessToken, refreshToken) => {
  localStorage.setItem(ACCESS_TOKEN_KEY,  accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

// ── Save user info ───────────────────────────────────
export const saveUser = (user) => {
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
};

// ── Get stored tokens ────────────────────────────────
export const getAccessToken  = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

// ✅ Fixed — null check before JSON.parse
export const getUser = () => {
  try {
    const user = localStorage.getItem(USER_KEY);
    if (!user || user === 'undefined' || user === 'null') return null;
    return JSON.parse(user);
  } catch {
    return null;
  }
};

// ── Clear all on logout ──────────────────────────────
export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// ── Check if token is expired ────────────────────────
export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

// ── Check if user is logged in ───────────────────────
export const isLoggedIn = () => {
  const token = getAccessToken();
  if (!token) return false;
  return !isTokenExpired(token);
};
